export class ReportConfiguration {
    id: number;
    useAlias: boolean;

    constructor(reportConfiguration?) {
        reportConfiguration = reportConfiguration || {};
        this.id = reportConfiguration.id || null;
        this.useAlias = reportConfiguration.useAlias || false;
    }
}



// WEBPACK FOOTER //
// ./src/app/main/models/report-configuration/report-configuration.ts